var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlanco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 93,
    viewBox: "0 0 394 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.92 45.4102V41.6302L149.5 92.1902H139.83L114.54 41.6302V45.1802L112.69 92.1902H100.38L103.29 22.4102H117.99L142.88 72.6302C143.67 74.1202 144.2 75.7202 144.6 76.8602C145 75.7202 145.66 74.1102 146.45 72.6302L171.34 22.4102H186.17L189.08 92.1902H176.63L174.91 45.4102H174.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.36 92.1999V22.4199H270.91V32.2599H228.54V52.2799H265.48V62.1199H228.54V82.3699H272.1V92.2099H216.35L216.36 92.1999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.06 92.1999L284.82 22.4199H298.46L322.03 73.0899C323.22 75.8399 324.28 78.8099 325.08 81.6699C326.01 78.8099 327.07 75.8399 328.12 73.0899L352.22 22.4199H365.46L332.09 92.1999H318.05H318.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.75 92.1999V22.4199H393.93V92.1999H381.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8401 8.35L57.4701 16.47L62.1001 12.35L45.8201 0H37.7401L21.5801 12.35L26.2201 16.47L41.8401 8.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.92 22.4199H33.63L0 92.1999H13.11L41.71 29.8499L70.45 92.1999H83.55L49.92 22.4199Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393.93,
    height: 92.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlanco);
export default __webpack_public_path__ + "static/media/logo_blanco.c8694662ed8c3736a7e2e9bed2fb8481.svg";
export { ForwardRef as ReactComponent };